import Vue from 'vue/dist/vue.esm'
import store from "./store"
import router from "./router"
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

import BaseShop from "../components/shopfront/containers/base_shop";

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#shopfront',
    router: router,
    components: { BaseShop },
    store: store
  });
});

